import { createSignal } from '@verclam/pulsar';

export type HomeScope =
	| { readonly kind: 'all' }
	| { readonly kind: 'organization'; readonly id: number }
	| { readonly kind: 'facility'; readonly id: number };

export const DEFAULT_HOME_SCOPE: HomeScope = { kind: 'all' };

const homeScopeSignal = createSignal<HomeScope>(DEFAULT_HOME_SCOPE);

export const setHomeScope = (scope: HomeScope): void => {
	homeScopeSignal.value = scope;
};

export default homeScopeSignal;
